import * as React from "react";
import PageLayout from "../../components/Shared/PageLayout";
import { EDPageLoader, grey } from "@trailblazer-game/ed-webkit";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";

const Event = dynamic(() => import("../../components/Pages/Event/Public/Event"), {
  suspense: false,
  ssr: false,
  loading: () => <EDPageLoader in={true}/>,
})
export default function EventPage() {
  const router = useRouter();
  const { key } = router.query;

  return <PageLayout justifyContent={"flex-start"} backgroundColor={grey("900")}>
    <Event eventKey={key as string}/>
  </PageLayout>
}

EventPage.metaData = {
  title: 'Eternal Dragons - Conquer Challenge Mode',
  description: 'Embark on a thrilling adventure in Eternal Dragons. Take on Challenge Mode and prove your prowess in dragon warfare. Can you emerge victorious and claim the ultimate prize?'
}